import { makeAutoObservable, autorun, runInAction } from 'mobx'
import { storeMobx } from 'restaurant'
import { PayApi } from 'api'
import { each } from '@dt/fe-utils/dist/lodash'

interface ISurcharge {
  [key: string]: {
    id: string;
    name: string;
    paymentSurchargeConfigUuid: string;
    rate: number;
  };
}

class Surcharge {
  constructor () {
    makeAutoObservable(this, {
      storeId: false
    })
  }

  storeId?: number

  surchargeMap: ISurcharge = {}

  async init (storeId: number, force?: boolean) {
    if (bo === 'cn') {
      return
    }
    if (storeId === this.storeId && !force) {
      return
    }
    this.storeId = storeId
    const res = await PayApi.querySurchargeConfigByStoreId(storeId)
    runInAction(() => {
      if (res) {
        each(res, (value: any, key: string) => {
          const _value = value[0]
          this.surchargeMap[key] = {
            ..._value,
            id: _value.paymentSurchargeConfigUuid
          }
        })
      }
    })
  }
}

const surchargeMobx = new Surcharge()

autorun(async () => {
  const { storeId } = storeMobx.info
  if (storeId) {
    surchargeMobx.init(storeId)
  } else {
    const pathState = document.location?.pathname?.match(/^\/([^/]*)\/?/)?.[1]
    if (Config.STOREID && pathState && ['mergeqr', 'mergeqrv2', 'posCheckout', 'posPayfail'].includes(pathState)) {
      setTimeout(() => {
        surchargeMobx.init(Config.STOREID)
      }, 1000)
    }
  }
})

export default surchargeMobx
